import React, { ReactNode } from 'react'
import { Typography } from 'antd'
import styled from 'styled-components/macro'
import { theme } from '../../utils/theme'

const { Text } = Typography

export type Size = 'S' | 'M' | 'L' | 'XL' | number

type SizeProps = {
  fontSize: string
  lineHeight: number
}

const SIZES: Record<Size, SizeProps> = {
  S: { fontSize: theme.fontSizes.extraSmall, lineHeight: 1.5 },
  M: { fontSize: theme.fontSizes.small, lineHeight: 1.71 },
  L: { fontSize: theme.fontSizes.medium, lineHeight: 1.33 },
  XL: { fontSize: theme.fontSizes.large, lineHeight: 1.5 }
}

export const StyledTitle = styled(Text)<{ size: Size }>`
  ${({ size }) => SIZES[size || 'M']}
  font-weight: bold;
  margin-bottom: 1em;
`

export type TitleProps = {
  size: Size
  text?: string
  children?: ReactNode | ReactNode[]
}

export const Title = ({ size, children, text, ...props }: TitleProps) => {
  return (
    <StyledTitle size={size} {...props}>
      {children || text}
    </StyledTitle>
  )
}
